import { useSearchParams } from 'react-router-dom'

import { convertCountryCode2to3, countryCode } from 'utils/i18n'

import { GlobalPrivacyNoticesList } from './global/global-privacy-notices-list'
import { KorPrivacyNoticesList } from './kr/kor-privacy-notices-list'

enum COUNTRY_TYPE {
  GLOBAL,
  KOR,
  TUR
}

export default function PrivacyNoticesList() {
  const [searchParam] = useSearchParams()
  const paramCountryCode = searchParam.get('countryCode')
  const effectiveCountryCode = paramCountryCode ? convertCountryCode2to3(paramCountryCode) : countryCode
  const country_type =
    effectiveCountryCode === 'KOR' ? COUNTRY_TYPE.KOR : effectiveCountryCode === 'TUR' ? COUNTRY_TYPE.TUR : COUNTRY_TYPE.GLOBAL

  return country_type === COUNTRY_TYPE.KOR ? <KorPrivacyNoticesList /> : <GlobalPrivacyNoticesList />
}
